const STRIPE_ERROR_MESSAGES: { [key: string]: string } = {
  card_declined: "Your card was declined. Please use a different card.",
  insufficient_funds: "Your card has insufficient funds. Please use a different card.",
  lost_card: "This card is reported as lost. Please use a different card.",
  stolen_card: "This card is reported as stolen. Please use a different card.",
  expired_card: "Your card has expired. Please use a different card.",
  incorrect_cvc: "The card security code (CVC) is incorrect.",
  processing_error: "We couldn't process this card right now. Please try again.",
  incorrect_number: "The card number is incorrect.",
  card_velocity_exceeded: "This card has exceeded the allowed number of attempts. Please try another card.",
  generic_decline: "Your card was declined. Please use a different card.",
  do_not_honor: "Your card was declined. Please use a different card."
};

function getStripeErrorCode(error: any): string {
  const code = error?.decline_code ||
    error?.code ||
    error?.raw?.decline_code ||
    error?.raw?.code ||
    error?.error?.decline_code ||
    error?.error?.code ||
    error?.error?.raw?.decline_code ||
    error?.error?.raw?.code;

  return (code || "").toString().toLowerCase();
}

export function getFriendlyStripeErrorMessage(error: any): string {
  const code = getStripeErrorCode(error);
  if (code && STRIPE_ERROR_MESSAGES[code]) {
    return STRIPE_ERROR_MESSAGES[code];
  }

  return (
    error?.error?.message ||
    error?.message ||
    "Payment failed. Please try another card."
  );
}

